var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderGrayColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2275_15508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56509 2.69025e-09C5.73983 -1.43678e-05 5.90971 0.0575436 6.04846 0.163773L6.12796 0.232939L8.27927 2.38504H13.5152C14.1236 2.38501 14.7089 2.61744 15.1516 3.03479C15.5942 3.45214 15.8606 4.02285 15.8963 4.63016L15.9003 4.77008V11.1302C15.9003 11.7385 15.6679 12.3239 15.2505 12.7665C14.8332 13.2091 14.2624 13.4756 13.6551 13.5112L13.5152 13.5152H2.38504C1.77669 13.5153 1.19132 13.2828 0.748695 12.8655C0.306075 12.4481 0.0396652 11.8774 0.00397516 11.2701L3.70512e-09 11.1302V2.38504C-3.38848e-05 1.77669 0.232402 1.19132 0.649751 0.748695C1.0671 0.306075 1.63781 0.0396652 2.24512 0.00397516L2.38504 2.69025e-09H5.56509Z",
    fill: "#605D62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2275_15508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9003,
    height: 13.5152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGrayColor);
export default __webpack_public_path__ + "static/media/Folder - gray Color.294e7fda282b9f68981a60b68508c0c8.svg";
export { ForwardRef as ReactComponent };